import React from 'react';
import PropTypes from 'prop-types';
import InfoBox from '@99designs/react-components/components/InfoBox';
import onboardingPrompt from 'contest/components/onboarding-prompts/onboardingPrompt.js';

export default function onboardingInfoBox(key, InnerComponent) {
    const InnerOnboardingInfoBox = props => {
        return (
            <InfoBox isDismissable={true} onDismiss={props.dismiss}>
                <InnerComponent {...props} />
            </InfoBox>
        );
    };

    InnerOnboardingInfoBox.propTypes = {
        dismiss: PropTypes.func.isRequired,
    };

    return onboardingPrompt(key, 500, InnerOnboardingInfoBox);
}



// WEBPACK FOOTER //
// ./src/web/js/contest/components/onboarding-prompts/onboardingInfoBox.js